// Shared option lists for the onboarding sections. Keeping them here
// (instead of hard-coded inside each section) means we only edit one file
// when the backend enum changes.

export const PRODUCT_KINDS = [
  { value: 'vehicle', label: 'Vehicle (auto)' },
  { value: 'atv', label: 'ATV' },
  { value: 'side_by_side', label: 'Side-by-side' },
  { value: 'boat', label: 'Boat' },
  { value: 'snowmobile', label: 'Snowmobile' },
  { value: 'rv', label: 'RV' },
];

export const SALES_MODELS = [
  { value: 'remote_delivery', label: 'Remote delivery (broker)' },
  { value: 'in_store', label: 'In-store (local retail)' },
];

export const COVERAGE_TYPES = [
  { value: 'nationwide', label: 'Nationwide' },
  { value: 'province_based', label: 'Province-based' },
  { value: 'radius_based', label: 'Radius-based' },
];

export const TRANSFER_TYPES = [
  { value: 'warm', label: 'Warm transfer' },
  { value: 'cold', label: 'Cold transfer' },
];

export const TRANSFER_FALLBACKS = [
  { value: 'schedule_callback', label: 'Schedule callback' },
  { value: 'send_sms', label: 'Send SMS' },
  { value: 'mark_missed', label: 'Mark missed' },
];

export const AGENT_TONES = [
  { value: 'soft', label: 'Soft' },
  { value: 'standard', label: 'Standard' },
  { value: 'assertive', label: 'Assertive' },
];

export const INVENTORY_MODES = [
  { value: 'none', label: 'None' },
  { value: 'website_crawl', label: 'Website crawl' },
  { value: 'manual_upload', label: 'Manual upload' },
  { value: 'both', label: 'Both' },
];

export const SYNC_FREQUENCIES = [
  { value: 'manual', label: 'Manual' },
  { value: 'daily', label: 'Daily' },
  { value: 'hourly', label: 'Hourly' },
];

export const PREFERRED_AI_PROVIDERS = [
  { value: 'none', label: 'None' },
  { value: 'openai', label: 'OpenAI' },
  { value: 'anthropic', label: 'Anthropic' },
];

export const STORAGE_PROVIDERS = [
  { value: 'none', label: 'None' },
  { value: 's3', label: 'AWS S3' },
  { value: 'r2', label: 'Cloudflare R2' },
];

export const FIRECRAWL_FREQS = [
  { value: 'manual', label: 'Manual' },
  { value: 'daily', label: 'Daily' },
  { value: 'hourly', label: 'Hourly' },
];

export const CALENDAR_PROVIDERS = [
  { value: 'none', label: 'None' },
  { value: 'google', label: 'Google Calendar' },
  { value: 'microsoft', label: 'Microsoft 365' },
];

// Sentinel echoed to the backend meaning "do not change this secret".
// The backend's secrets.apply_patch recognises it and keeps the stored value.
export const SECRET_UNCHANGED = '__SECRET_UNCHANGED__';
